module.exports = __webpack_public_path__ + "img/clock.27da240f.svg";